/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IAai20Visitor } from '../visitors/IAai20Visitor';
import { Node } from '../../../core/models/Node';
import { AuthorizationCodeOAuthFlow } from '../../../core/models/common/AuthorizationCodeOAuthFlow';
import { IVisitor } from '../../../core/visitors/IVisitor';

/**
 * @author Jakub Senko <jsenko@redhat.com>
 * @param {Node} parent
 * @class
 * @extends AuthorizationCodeOAuthFlow
 */
export class Aai20AuthorizationCodeOAuthFlow extends AuthorizationCodeOAuthFlow {
    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null)) {
            let __args = arguments;
            super();
            (() => {
                /* requireNonNull */if(parent==null){throw new Error('cannot be null')};
                this._parent = parent;
                this._ownerDocument = parent.ownerDocument();
            })();
        } else if(parent === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let v : IAai20Visitor = <IAai20Visitor><any>visitor;
        v.visitAuthorizationCodeOAuthFlow(this);
    }
}
Aai20AuthorizationCodeOAuthFlow["__class"] = "io.apicurio.datamodels.asyncapi.v2.models.Aai20AuthorizationCodeOAuthFlow";
Aai20AuthorizationCodeOAuthFlow["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




